module.exports = __webpack_public_path__ + "img/card-front-design.35615123.png";